var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.707 15.293a1 1 0 0 0 -1.414 0l-2.793 2.793-2.793-2.793a1 1 0 0 0 -1.414 1.414l2.793 2.793-2.793 2.793a1 1 0 1 0 1.414 1.414l2.793-2.793 2.793 2.793a1 1 0 0 0 1.414-1.414l-2.793-2.793 2.793-2.793a1 1 0 0 0 0-1.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 22a10 10 0 1 1 10-10 1 1 0 0 0 2 0 12 12 0 1 0 -12 12 1 1 0 0 0 0-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 6a1 1 0 0 0 -1 1v4.586l-2.707 2.707a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 .293-.707v-5a1 1 0 0 0 -1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDelete);
export default __webpack_public_path__ + "static/media/time-delete.882ddbb1a0b2f6f538a89b70a1c50689.svg";
export { ForwardRef as ReactComponent };